import { render } from "./footer.vue?vue&type=template&id=febb13ce&bindings={\"navigate\":\"props\",\"navRoute\":\"options\"}"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./footer.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script